// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._492541{max-height:20em !important;color:var(--secondary);font-size:.875em}", ""]);
// Exports
exports.locals = {
	"list": "_492541"
};
module.exports = exports;
